<template>
  <div class="opc-capacity-select">
    <div class="opc-capacity-select__left">
      <div class="opc-capacity-select__label">
        {{ label }}
      </div>
      <div class="opc-capacity-select__helper" v-if="helper">
        <p class="opc-capacity-select__helper-text">{{ helper }}</p>
      </div>
    </div>
    <div class="opc-capacity-select__right">
      <div class="opc-capacity-select__select-wrapper">
        <zm-select
          :model-value="value"
          :disabled="disabled"
          size="large"
          class="opc-capacity-select__select"
          data-testid="simple-edit-capacity-select"
          @update:model-value="handleChange"
        >
          <zm-option
            v-for="option in options"
            :key="option"
            :label="toThousands(option)"
            :value="option"
          />
        </zm-select>
      </div>
    </div>
  </div>
</template>

<script>
import { toThousands } from "@/utils/money";

export default {
  name: 'CapacitySelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    helper: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toThousands,
    handleChange(value) {
      this.$emit('change', value);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/scss-utils';
@import '@/styles/variables';

.opc-capacity-select {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;

  &__left {
    display: flex;
    flex: 1 0 0;
    flex-direction: column;
    gap: 2px;
  }

  &__right {
    flex: 1 0 0;
  }

  &__label {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.31px;
  }

  &__helper-text {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--zoom-color-text-neutral, #686F79);
  }

  &__select-wrapper {
    width: 140px;
    min-height: 40px;

    & :deep(.zbo-select-input__wrapper) {
      min-height: 40px;
    }
  }

  &__select {
    width: 100%;
    //border: 1px solid #c1c6ce;
  }
}
</style>

